import { useEffect } from 'react';

export function useModalScrollLock() {
  useEffect(() => {
    const scrollY = window.scrollY || window.pageYOffset || 0;
    const html = document.documentElement;
    const body = document.body;
    const previousHtmlOverflow = html.style.overflow;
    const previousBodyOverflow = body.style.overflow;
    const previousBodyPosition = body.style.position;
    const previousBodyTop = body.style.top;
    const previousBodyWidth = body.style.width;
    const scrollContainers = Array.from(document.querySelectorAll<HTMLElement>('[data-funnel-scroll]'));
    const previousContainerOverflow = scrollContainers.map((el) => el.style.overflowY);

    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.width = '100%';
    scrollContainers.forEach((el) => {
      el.style.overflowY = 'hidden';
    });

    return () => {
      html.style.overflow = previousHtmlOverflow;
      body.style.overflow = previousBodyOverflow;
      body.style.position = previousBodyPosition;
      body.style.top = previousBodyTop;
      body.style.width = previousBodyWidth;
      scrollContainers.forEach((el, index) => {
        el.style.overflowY = previousContainerOverflow[index] || '';
      });
      if (process.env.NODE_ENV !== 'test') {
        window.scrollTo(0, scrollY);
      }
    };
  }, []);
}
